import React from "react";
import { Box } from "@mui/material";
import { stepsConfig } from "../step-config";
import { useStepCompletion } from "../hooks/useStepCompletion";
import "./StepHeader.css";

type Props = {
  activeIndex: number;
};

export default function StepHeader({ activeIndex }: Props) {
  const completions = useStepCompletion();

  return (
    <Box sx={{ maxWidth: 1100, mx: "auto" }}>
      <div className="onb-steps">
        {stepsConfig.map((s, i) => {
          const status = completions[s.id as keyof typeof completions];
          const isCompleted = status?.isCompleted || false;
          const isBeforeActive = i < activeIndex;
          const showCheckmark = isCompleted && i !== activeIndex;
          
          return (
            <div 
              key={s.id} 
              className={`onb-step ${isCompleted ? 'completed' : ''} ${i === activeIndex ? 'active' : ''}`}
            >
              <div className={`onb-line ${isBeforeActive && isCompleted ? 'completed-line' : ''}`} />
              <div className="onb-dot">
                {showCheckmark ? '✓' : i + 1}
              </div>
              <div className="onb-label">{s.title}</div>
            </div>
          );
        })}
      </div>
    </Box>
  );
}


